<template>
  <div class="seckill-progress-component">
    <div class="seckill-progress-title">
      {{ title }}
    </div>
    <div class="seckill-progress-content">
      <div v-for="item in days"
           :key="item"
           class="seckill-progress-item"
           :class="[
             { 'is-past': compareDayTime(item, currentTime) === -1 },
             { 'is-current': compareDayTime(item, currentTime) === 0 },
           ]"
      >
        {{ item | formatTime('M.d', false) }}
      </div>
    </div>
    <div class="seckill-progress-activity-time">
      {{ activityTime }}
    </div>
  </div>
</template>

<script>
  import { formatTime } from '@/utils';

  export default {
    name: 'SeckillProgress',
    props: {
      title: String,
      days: {
        type: Array,
        required: true,
      },
      currentTime: {
        type: Number,
        required: true,
      },
    },
    computed: {
      activityTime() {
        const { days } = this;
        const min = Math.min.apply(this, days);
        const max = Math.max.apply(this, days);
        const format = time => formatTime(time, 'MM月d日', false);
        return `活动时间：${format(min)}-${format(max)}`;
      },
    },
    methods: {
      compareDayTime(time1, time2) {
        if (time1 < time2) return -1;
        const getDay = time => formatTime(time, 'MMdd');
        const day1 = getDay(time1);
        const day2 = getDay(time2);
        if (day1 === day2) return 0;
        return 1;
      },
    },
  };
</script>

<style scoped lang="less">
  @import '~@/assets/styles/var.less';

  @progress-item-dark: darken(@seckill-primary-2, 3%);
  @progress-item-light: spin(lighten(@seckill-primary-2, 20%), 3);
  @progress-item-lighter: spin(lighten(@seckill-primary-2, 29%), -1);
  @progress-item-width: 70px;
  @progress-item-height: 36px;
  @progress-item-dot-size: 12px;
  @progress-item-dot-bottom: @progress-item-dot-size + 8px;
  .seckill-progress {
    &-component {
      padding: @size-base 24px;
      text-align: center;
      color: @color-white;
      background: @seckill-primary-gradient-column;
    }

    &-title {
      font-size: @font-size-extra-large;
      font-weight: @font-weight-bold;
    }

    &-content {
      display: flex;
      justify-content: space-between;
      margin-top: @size-base;
      padding-bottom: 12px;
      border-bottom: 2px dotted @color-white;
    }

    &-item {
      box-sizing: border-box;
      width: @progress-item-width;
      height: @progress-item-height;
      padding-top: 4px;
      position: relative;
      text-align: center;
      font-size: @font-size-small;
      line-height: 1;
      color: @progress-item-lighter;
      background-image: url('~@/assets/img/seckill/progress_item_bg__normal.png');
      background-size: cover;
      background-repeat: no-repeat;

      &::after {
        content: '';
        display: block;
        width: @progress-item-dot-size;
        height: @progress-item-dot-size;
        position: absolute;
        bottom: -@progress-item-dot-bottom;
        left: 50%;
        transform: translate3d(-50%, 0, 0);
        border-radius: @progress-item-dot-size;
        background: @progress-item-lighter;
      }

      &.is-current {
        color: @progress-item-dark;
        background-image: url('~@/assets/img/seckill/progress_item_bg__current.png');

        &::after {
          background: @color-white;
        }
      }

      &.is-past {
        color: @progress-item-dark;
        background-image: url('~@/assets/img/seckill/progress_item_bg__past.png');
      }
    }

    &-activity-time {
      display: inline-block;
      margin-top: @size-small + @progress-item-dot-size/2;
      padding: @size-extra-small @size-small;
      font-size: @font-size-base;
      font-weight: @font-weight-bold;
      color: @color-text-base;
      background: @color-white;
      border-radius: @border-radius-normal;
    }
  }
</style>
